import lockupUrl from "../assets/brand/kaleido-lab-lockup.svg";
import lockupWhiteUrl from "../assets/brand/kaleido-lab-lockup-white.svg";
import markUrl from "../assets/brand/kaleido-lab-mark.svg";
import { useSystemInfo } from "../lib/system";
import { cn } from "../lib/utils";

/** Makes it obvious which environment you are working in. */
export function EnvBadge({ className }: { className?: string }) {
  const { data } = useSystemInfo();
  if (!data || data.env === "production") return null;
  const label = data.env === "test" ? "Testumgebung" : "Entwicklung";
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold",
        data.env === "test" ? "bg-amber-100 text-amber-800" : "bg-sky-100 text-sky-800",
        className,
      )}
      title={`Version ${data.version}`}
    >
      {label}
    </span>
  );
}

export const BRAND_NAME = "Kaleido Lab";

/**
 * Horizontal word-and-image mark. The wordmark is an image asset by brand rule
 * (never re-set in a font); keep it at least 160 px wide – below that use `Mark`.
 */
export function Logo({
  className,
  size = "md",
  tone = "dark",
}: {
  className?: string;
  size?: "md" | "lg";
  /** Colour of the wordmark: dark on light surfaces, light on dark ones. */
  tone?: "dark" | "light";
}) {
  return (
    <img
      src={tone === "light" ? lockupWhiteUrl : lockupUrl}
      alt={BRAND_NAME}
      width={size === "lg" ? 200 : 160}
      height={size === "lg" ? 40 : 32}
      className={cn(
        "block shrink-0 select-none",
        size === "lg" ? "h-10 w-50" : "h-8 w-40",
        className,
      )}
      draggable={false}
    />
  );
}

/** The coloured K on its own, for spots too small for the full logo (min. 24 px). */
export function Mark({ className, title }: { className?: string; title?: string }) {
  return (
    <img
      src={markUrl}
      alt={title ?? BRAND_NAME}
      width={28}
      height={28}
      className={cn("block size-7 shrink-0 select-none", className)}
      draggable={false}
    />
  );
}
